/**
 * AnimateSections Class
 */
export class AnimateSections {

	/**
	 * Sets up the Intersection Observer.
	 * @param {string} excludeSelector - CSS selector for blocks to exclude from animation
	 */
	constructor( excludeSelector = "" ) {

		this.excludeSelector = excludeSelector;
		this.initObserver();

	}

	/**
	 * Initializes the Intersection Observer and observes all Sections on page.
	 */
	initObserver() {

		this.observer = new IntersectionObserver(
			this.handleIntersect.bind( this ),
			{ threshold: 0 },
		);

		const selector = "main > article > *";
		let elements = Array.from( document.querySelectorAll( selector ) );

		if ( this.excludeSelector ) {

			elements = elements.filter(
				( el ) => !el.matches( this.excludeSelector ),
			);

		}

		elements.forEach( ( element ) => this.observer.observe( element ) );

	}

	/**
	 * Adds the 'animate' class to intersecting elements
	 *
	 * @param {IntersectionObserverEntry[]} entries - Array of observed elements' intersection states.
	 */
	handleIntersect( entries ) {

		entries.forEach( ( entry ) => {

			if ( entry.isIntersecting ) {

				entry.target.classList.add( "animate" );
				this.observer.unobserve( entry.target );

			}

		} );

	}

}
